<i18n>
{
  "ja": {
    "onLineBriefing": {
      "title": "自家倉庫の登録説明会（オンライン）",
      "description": "登録を検討中の自家倉庫オーナー様を対象に、詳しい説明会を開催しています",
      "form": "参加お申込みフォーム"
    }
  }
}
</i18n>
<template>
  <section class="wrap">
    <div class="scroll"></div>
    <h2 class="head"><span class="line"><b>まずは登録から！</b><br /><span class="hidden md:inline">ご不明点は</span>お気軽にお問い合わせください！</span></h2>
    <div class="inner">
      <div class="items">
        <div class="item">
          <div class="flex flex-col">
            <h3 class="item-hd">
              <img src="@/assets/img/fortheowners/fukidashi.svg" alt="">
              <span class="pt-5 pl-1">倉庫登録はこちらから！</span>
              <img style="transform: scale(-1,1)" src="@/assets/img/fortheowners/fukidashi.svg" alt="">
            </h3>
            <nuxt-link class="link-img" :to="localePath('contact')" :href="localePath('contact')" :target="_self">
              <img :src="require('@/assets/img/fortheowners/pre_registration.png')" alt="">
            </nuxt-link>
          </div>
        </div>

        <div v-if="seminar && seminar.slug" class="item">
          <div class="flex flex-col">
            <h3 class="item-hd">
              <img src="@/assets/img/fortheowners/fukidashi2.svg" alt="">
              <span class="pt-5 pl-1">もっと説明を聞きたい方へ</span>
              <img style="transform: scale(-1,1)" src="@/assets/img/fortheowners/fukidashi2.svg" alt="">
            </h3>
            <nuxt-link class="link-img" :to="`/seminar/${seminar.slug}`">
              <img :src="seminar.thumbnail.url" alt="">
            </nuxt-link>
            <p class="text-black md:text-xl text-left font-bold mb-3">自家倉庫の登録説明会</p>
            <p class="my-auto text-left text-xs md:text-base">{{$t('onLineBriefing.description')}}</p>
          </div>
        </div>
      </div>

      <p v-if="!!whitePaper" class="mt-16 mx-8 mb-4 md:mx-0 md:mb-0">
        <nuxt-link class="bnr" :to="`/whitepaper/${whitePaper.slug}`">
          <picture>
            <source srcset="@/assets/img/fortheowners/bnr.png" media="(min-width: 768px)">
            <img src="@/assets/img/fortheowners/bnr_sp.png" class="mx-auto" alt="">
          </picture>
        </nuxt-link>
      </p>
    </div>
  </section>
</template>

<style scoped lang="scss">
.bnr {
  &:hover {
    @apply shadow-panel;
  }
  @screen md {
    @apply duration-300 transition-shadow block rounded-xl overflow-hidden;
  }
}
.link-img {
  @apply block mt-4 mb-5 rounded overflow-hidden duration-300 transition-shadow;
  &:hover {
    @apply shadow-panel;
  }
  @screen md {
    @apply mb-6;
  }
}
.items {
  @apply px-8;
  @screen md {
    @apply flex justify-center px-0 -mx-8;
  }
}
.item {
  @apply mb-12;
  &-hd {
    @apply flex justify-center font-bold text-xl;
  }
  @screen md {
    width: 400px;
    @apply mb-0 mx-8;
  }
}
.inner {
  max-width: 860px;
  @apply mx-auto;
}
.wrap {
  color: #333;
  @apply relative mt-12 py-12 bg-secondary-lightest text-center;
  @screen md {
    @apply mt-12 py-20;
  }
}
.head {
  @apply text-xl font-bold mb-10;
  b {
    @apply text-2xl font-bold;
  }
  @screen md {
    font-size: 32px;
    letter-spacing: 1.92px;
    line-height: 1.7;
    b {
      font-size: 32px;
    }
  }
}
.scroll {
  width: 2px;
  height: 40px;
  background-color: #13A298;
  @apply absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2;
  @screen md {
    height: 120px;
  }
}
</style>

<script>
export default {
  props: {
    seminar: { default: null },
    whitePaper: { default:null },
    registration: { default: false }
  }
}
</script>
